import React, { Component } from 'react';
import { withRouter } from "react-router";
import ImgView from 'components/common/FileController/ImgView';
import { Modal, Button, Tabs } from 'antd';

class PreviewModal extends Component {

  render() {
    const {
      modalOpen,
      modalClose,
      companyData,
    } = this.props;

    return (
      <Modal
        width={1300}
        title="미리보기"
        okText={"확인"}
        visible={modalOpen}
        onCancel={modalClose}
        footer={
          <Button
            onClick={modalClose}
          >확인</Button>
        }
      >
        <br />
        <Tabs type="card">
        {companyData !== undefined && companyData !== null && companyData.map((item)=>{
          return(
          <Tabs.TabPane tab={item.cpTabNm} key={item.cpTabCd} forceRender>
            <ImgView
              fileInfo={item.cpImgInfo}
            />
          </Tabs.TabPane>
          )
        })}
        </Tabs>
      </Modal>
    );
  }

}

export default withRouter(PreviewModal);
